export const NON_MOBILE_DEVICE_SCREEN_TYPES = {
  SMS: 'SMS',
  QR: 'QR'
};

export const MOBILE_DEVICE_CHECK_COOKIE = 'mobileDeviceChecked';
